import { render } from "./ErrorBoundary.vue?vue&type=template&id=245fc74c&scoped=true&ts=true"
import script from "./ErrorBoundary.vue?vue&type=script&lang=ts"
export * from "./ErrorBoundary.vue?vue&type=script&lang=ts"

import "./ErrorBoundary.vue?vue&type=style&index=0&id=245fc74c&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245fc74c"]])

export default __exports__